import {
  SET_NO_DATES_AVAILABLE_FOR_REG_SCHEDULER,
  UPDATE_TOTAL_FOR_REG_SCHEDULER,
  UPDATE_SQUAD_QTY_FOR_REG_SCHEDULER,
  SET_SELECTED_DATE,
  DISPLAY_AVAILABLE_DATES,
  DISPLAY_SQUADS,
  DISPLAY_BOWLER_OWNED_VIRTUAL_EVENTS,
  UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER,
  UPDATE_TEAM_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER,
  UPDATE_SQUAD_COUNT_IN_CART_FOR_REG_SCHEDULER,
  UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER,
  UPDATE_TEAM_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER,
  SET_CALENDAR_SELECTED_DATE,
  DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED
} from './constants';

import {
  UPDATE_SCHEDULER_SQUAD_COUNT,
  UPDATE_SCHEDULER_VIRTUAL_EVENT_COUNT,
  CLEAR_SCHEDULER_ITEMS,
  BOWLER
} from 'shared/constants';

const initialState = {
  noDatesAvailable: false,
  calendar: {},
  events: [],
  total: 0,
  virtualEvents: [],
  allEvent: {}
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case SET_CALENDAR_SELECTED_DATE: {
      state.calendar.selectedDate = payload;
      return {
        ...state
      };
    }

    case SET_NO_DATES_AVAILABLE_FOR_REG_SCHEDULER:
      return {
        ...state,
        noDatesAvailable: payload || false
      };

    case UPDATE_TOTAL_FOR_REG_SCHEDULER: {
      const cart = {
        squads: payload.squads || [],
        virtualEvents: payload.virtualEvents || []
      };

      let total = 0;

      total += cart.squads
        .reduce((acc, squad) => acc + squad.quantity * squad.eventTotalPrice, 0);
      total += cart.virtualEvents
        .reduce((acc, virtualEvent) => acc + virtualEvent.quantity * virtualEvent.price, 0);

      return {
        ...state,
        total
      };
    }

    case UPDATE_SQUAD_QTY_FOR_REG_SCHEDULER: {
      let newQty = payload.inputValue;

      if(payload.inputValue > payload.max) {
        newQty = payload.max;
      } else if(payload.inputValue < 0) {
        newQty = 0;
      }

      state.events.forEach(item => {
        item.squads.forEach(squad => {
          if(squad.id === payload.squadId) {
            if (payload.addedToCart && squad.available && squad.quantity) {
              // If payload.addedToCart is true means squads were just added to the cart
              // so we need to update the availability
              squad.available = squad.available - squad.quantity;
            }
            squad.quantity = Number(newQty);
            if (payload.removedFromCart && squad.available) {
              // If payload.addedToCart is true means squads were just added to the cart
              // so we need to update the availability
              squad.available = squad.available + 1;
            }
            squad.quantity = Number(newQty);
          }
        });
      });
      return {
        ...state,
        ...{events: [...state.events]}
      };
    }

    case SET_SELECTED_DATE:
      return {
        ...state,
        calendar: {
          ...state.calendar,
          selectedDate: payload
        }
      };

    case DISPLAY_AVAILABLE_DATES:
      return {
        ...state,
        calendar: payload
      };

    case DISPLAY_SQUADS: {
      const cart = {
        squads: payload.cart.squads || []
      };

      payload.events.forEach(item => {
        item.squads.forEach(squad => {
          const cartSquad = cart.squads.find(x => x.id === squad.id) || null;

          if(cartSquad !== null) {
            squad.countInCart = cartSquad.quantity;
            squad.available = squad.available - cartSquad.quantity;
          }

          squad.showBundleGuide = false;
        });

        const virtualEventCart = {
          virtualEvents: payload.cart.virtualEvents || []
        };
  
        const virtualEvents = item.teamOwnedVirtualEvents || [];
  
        virtualEvents.forEach(virtualEvent => {
          const cartVirtualEvent = virtualEventCart.virtualEvents.find(x => x.id === virtualEvent.id) || null;
  
          if(cartVirtualEvent !== null) {
            virtualEvent.countInCart = cartVirtualEvent.quantity;
          } else {
            virtualEvent.countInCart = Number(0);
          }

          virtualEvent.quantity = Number(0);
        });
      });

      return {
        ...state,
        ...{events: payload.events}
      };
    }

    case DISPLAY_BOWLER_OWNED_VIRTUAL_EVENTS: {
      const cart = {
        virtualEvents: payload.cart.virtualEvents || []
      };

      const virtualEvents = payload.virtualEvents || [];

      virtualEvents.forEach(virtualEvent => {
        const cartVirtualEvent = cart.virtualEvents.find(x => x.id === virtualEvent.id) || null;

        if(cartVirtualEvent !== null) {
          virtualEvent.countInCart = cartVirtualEvent.quantity;
        } else {
          virtualEvent.countInCart = Number(0);
        }
      });

      return {
        ...state,
        virtualEvents: virtualEvents.map(virtualEvent => { 
          if (virtualEvent.owner === BOWLER) {
            return { ...virtualEvent, quantity: Number(0) }; 
          }
        }).filter(virtualEvent => virtualEvent)
      };
    }

    case UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER: {
      return {
        ...state,
        virtualEvents: state.virtualEvents.map(virtualEvent => {
          if (virtualEvent.id === payload.virtualEventId){
            return {
              ...virtualEvent,
              quantity: !payload.quantity ? 0 : Number(payload.quantity)
            };
          }

          return virtualEvent;
        })
      };
    }

    case UPDATE_TEAM_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER: {
      return {
        ...state,
        events: state.events.map(event => {
          if (event.id === payload.eventId){
            return {
              ...event,
              teamOwnedVirtualEvents: event.teamOwnedVirtualEvents.map(virtualEvent => {
                if (virtualEvent.id === payload.virtualEventId){
                  return {
                    ...virtualEvent,
                    quantity: !payload.quantity ? 0 : Number(payload.quantity)
                  };
                }

                return virtualEvent;
              })
            };
          }

          return event;
        })
      };
    }

    case DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED:
    case UPDATE_SQUAD_COUNT_IN_CART_FOR_REG_SCHEDULER: {
      return {
        ...state,
        events: state.events.map(x => eventReducer(x, {type, payload}))
      };
    }

    case UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER: {
      return {
        ...state,
        virtualEvents: state.virtualEvents.map(virtualEvent => {
          if (virtualEvent.id === payload.virtualEventId){
            return {
              ...virtualEvent,
              countInCart: virtualEvent.countInCart
                ? virtualEvent.countInCart + Number(payload.count)
                : Number(payload.count)
            };
          }

          return virtualEvent;
        })
      };
    }

    case UPDATE_TEAM_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER: {
      return {
        ...state,
        events: state.events.map(event => {
          if (event.id === payload.eventId){
            return {
              ...event,
              teamOwnedVirtualEvents: event.teamOwnedVirtualEvents.map(virtualEvent => {
                if (virtualEvent.id === payload.virtualEventId){
                  return {
                    ...virtualEvent,
                    countInCart: virtualEvent.countInCart
                      ? virtualEvent.countInCart + Number(payload.count)
                      : Number(payload.count)
                  };
                }

                return virtualEvent;
              })
            };
          }

          return event;
        })
      };
    }

    case UPDATE_SCHEDULER_SQUAD_COUNT: {
      // REG-2531
      // const events = state.events.slice();
      // let event = events.find(item => item.id == payload.squad.eventId);
      // let squadInScheduler = event.squads.find(item => item.id == payload.squad.id);
      let squadInScheduler = payload.squad;

      if (squadInScheduler) {
        squadInScheduler.countInCart = payload.count;
      }
      
      return {
        ...state
        // events: events
      };
    }

    case UPDATE_SCHEDULER_VIRTUAL_EVENT_COUNT: {
      const events = state.events.slice();
      const virtualEvents = state.virtualEvents.slice();

      let virtualEventInScheduler = undefined;
      
      if (payload.virtualEvent.eventId){
        let parentEvent = events.find(item => item.id == payload.virtualEvent.eventId);

        if (parentEvent) {
          virtualEventInScheduler = parentEvent.teamOwnedVirtualEvents.find(item => item.id == payload.virtualEvent.id);
        }
      } else {
        virtualEventInScheduler = virtualEvents.find(item => item.id == payload.virtualEvent.id);
      }
      
      if (virtualEventInScheduler) {
        virtualEventInScheduler.countInCart = payload.count;
      }
      
      return {
        ...state,
        events: events,
        virtualEvents: virtualEvents
      };
    }

    case CLEAR_SCHEDULER_ITEMS: {
      const events = state.events.slice();
      const virtualEvents = state.virtualEvents.slice();

      events.forEach(event => {
        event.squads.forEach(squad => squad.countInCart = 0);
        event.teamOwnedVirtualEvents.forEach(virtualEvent => virtualEvent.countInCart = 0);
      });

      virtualEvents.forEach(virtualEvent => virtualEvent.countInCart = 0);

      return {
        ...state,
        events: events,
        virtualEvents: virtualEvents
      };
    }

    default:
      return state;
  }
};

const eventReducer = (state = {}, {type, payload}) => {
  switch (type) {
    case DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED:
    case UPDATE_SQUAD_COUNT_IN_CART_FOR_REG_SCHEDULER:
      return {
        ...state,
        squads: state.squads.map(x => squadReducer(x, {type, payload}))
      };
    default:
      return state;
  }
};

const squadReducer = (state = {}, {type, payload}) => {
  switch (type) {
    case DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED: {
      return state.id === payload
        ? {
          ...state,
          showBundleGuide: state.hasBundledChild
        }
        : state;
    }
    case UPDATE_SQUAD_COUNT_IN_CART_FOR_REG_SCHEDULER: {
      return state.id === payload.squadId
        ? {
          ...state,
          countInCart: state.countInCart ? (state.countInCart + payload.quantity) : payload.quantity
        }
        : state;
    }
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/registration/scheduler/reducer.js